<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Photos" parent-page-url="/photos" />
      <add-edit-form
        v-if="model"
        returnUrl="/photos"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Photo from '@/models/Photo'
/* eslint-disable no-undef */
export default {
  name: 'AddPhoto',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Photo' : 'Add Photo'
    }
  },
  data () {
    return {
      API_BASE_URL: 'photo',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Photo number', key: 'photo_no', type: 'text' },
        { label: 'UPC', key: 'upc', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'Keywords', key: 'keywords', type: 'text', placeholder: 'Comma Separated Keywords' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Photo()
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Photo(result.photo)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Photos/AddEdit.vue